import type {
    ParsePathParams,
    RegisteredRouter,
    SearchParamOptions,
    RoutePaths as TanstackRoutePaths,
} from '@tanstack/react-router';
import type { Prettify } from '@mews/std';

export const enterpriseRoutePrefix = '/$currentEnterpriseId/';

type StripCurrentEnterpriseId<T> = T extends `${typeof enterpriseRoutePrefix}${infer R}` ? R : never;

export type RoutePaths = TanstackRoutePaths<RegisteredRouter['routeTree']>;
type EnterprisePathInternal = StripCurrentEnterpriseId<RoutePaths>;
// fallback to generic string when routes aren't defined
export type EnterprisePaths = string extends RoutePaths ? string : EnterprisePathInternal;

interface OptionalCurrentEnterpriseIdParams {
    currentEnterpriseId?: string;
}

type ParamsFromPath<To extends string> = Record<ParsePathParams<To>, string>;

export type ParamsProps<To extends EnterprisePaths> = ParamsFromPath<To> extends Record<string, never>
    ? { params?: Prettify<OptionalCurrentEnterpriseIdParams> }
    : { params: Prettify<ParamsFromPath<To> & OptionalCurrentEnterpriseIdParams> };

export type SearchProps<To extends EnterprisePaths, From> = SearchParamOptions<
    RegisteredRouter,
    From,
    `${typeof enterpriseRoutePrefix}${To}`
>;

export type SearchParams<To extends EnterprisePaths> = Exclude<
    NonNullable<SearchProps<To, string>['search']>,
    Function | boolean
>;
